import { render, staticRenderFns } from "./PendingData.vue?vue&type=template&id=022e1ecf&"
import script from "./PendingData.vue?vue&type=script&lang=js&"
export * from "./PendingData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports